import styled from '@emotion/styled';
import {colors, fontSize, sizes} from 'patient-ping-remedy/packages/theme';
import {StandardSemiBoldTypography} from 'patient-ping-remedy/packages/typography';

export const StepName = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${sizes.xxSmall};
`;

export const Title = styled(StandardSemiBoldTypography)`
  font-weight: bold;
  font-size: ${fontSize.displaySmall};
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${sizes.small};
`;

export const Completion = styled.div`
  display: flex;
  align-items: center;
  gap: ${sizes.xxSmall};
`;

export const StyledChip = styled('button')`
  display: inline-block;
  font-size: ${fontSize.small};
  line-height: 1.8rem;
  border-radius: ${sizes.xSmall};
  padding: 0.3rem ${sizes.xSmall};
  border: 1px solid ${colors.red3};
  background-color: ${colors.orange4};
  color: ${colors.white};
  margin-top: ${sizes.xSmall};  
`;

